<template>
  <div v-if="config.report_id" class="details">
    <div class="detailRow">
      <span class="detailLabel">REPORT</span>
      <span class="detailValue">{{ config.report_name || config.report_id }}</span>
    </div>
    <div class="detailRow">
      <span class="detailLabel">ID</span>
      <span class="detailValue mono">{{ config.report_id }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  config: Record<string, any>
}>()
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.detailRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}
.detailValue {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
}
.detailValue.mono {
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: var(--fs-xs);
}
</style>
